import { getPath } from '@/router/common'

const baseUrl = {
  title: '展示图片',
  path: 'zzjg'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'ZzjgIndex',
    component: () =>
      import(/* webpackChunkName: "ZzjgIndex" */ '@/views/zzjg/index/index.vue'),
    meta: {
      title: '架构设置'
    }
  },
  {
    path: getPath('LinesInOperation', baseUrl),
    name: 'LinesInOperation',
    component: () =>
      import(
        /* webpackChunkName: "LinesInOperation" */ '@/views/zzjg/linesInOperation/index.vue'
      ),
    meta: {
      title: '区域线路'
    }
  },
  {
    path: getPath('LevelTwoTransfer', baseUrl),
    name: 'LevelTwoTransfer',
    component: () =>
      import(
        /* webpackChunkName: "LevelTwoTransfer" */ '@/views/zzjg/levelTwoTransfer/index.vue'
      ),
    meta: {
      title: '二级中专市县'
    }
  },
  {
    path: getPath('B_other_companyAdd', baseUrl),
    name: 'B_other_companyAdd',
    component: () =>
      import(
        /* webpackChunkName: "B_other_companyAdd" */ '@/views/zzjg/b_other_companyAdd/index.vue'
      ),
    meta: {
      title: '增加公司'
    }
  },
  {
    path: getPath('B_other_company', baseUrl),
    name: 'B_other_company',
    component: () =>
      import(
        /* webpackChunkName: "B_other_company" */ '@/views/zzjg/b_other_company/index.vue'
      ),
    meta: {
      title: '网点'
    }
  },
  {
    path: getPath('LevelTwoTransferAdd', baseUrl),
    name: 'LevelTwoTransferAdd',
    component: () =>
      import(
        /* webpackChunkName: "LevelTwoTransferAdd" */ '@/views/zzjg/levelTwoTransferAdd/index.vue'
      ),
    meta: {
      title: '增加公司'
    }
  },
  {
    path: getPath('BatchAdd', baseUrl),
    name: 'BatchAdd',
    component: () =>
      import(
        /* webpackChunkName: "BatchAdd" */ '@/views/zzjg/batchAdd/index.vue'
      ),
    meta: {
      title: '批量新增'
    }
  },
  {
    path: getPath('BranchesRebates', baseUrl),
    name: 'zzjg_BranchesRebates',
    component: () => import(/* webpackChunkName: "zzjg_BranchesRebates" */ '@/views/zzjg/branchesRebates/index.vue'),
    meta: {
      title: '网点返点报表'
    }
  },
]
